import { useState, useEffect, useCallback, Fragment } from 'react';
import { Link, Route, Routes, useNavigate, useLocation } from 'react-router-dom';

import { Button, CircularProgress, Grid, Typography, Tab, Tabs, TableCell } from '@mui/material';
import { Dialog } from 'style-guide';
import OrderTable from './OrderTable/OrderTable';
import OrderForm from './OrderForm';
import OrderSearch from './OrderTable/OrderSearch';
import { styled } from '@mui/system';

import * as XLSX from 'xlsx';
import { sendRequest, REQUEST_ACTIONS, setOrderData, parseOrderData } from 'utils/Communicator';
import { getOrders, onPageChange, onUnConfirmedOrdersCountChange } from 'reducers/order-reducers/ordersSlicer';
import { onUnConfirmedParcelsCountChange } from 'reducers/parcel-reducers/ordersSlicer';
import { useDispatch, useSelector } from 'react-redux';
import AdvSearchDialog from './OrderTable/AdvSearchDialog';
import { STAGES_OPTIONS, USA_STATES } from 'constants/global-constants';
import { addOrderFilter, addSearchFilter, usePrevious, StyledTableCell, advancedSearchDefaultStyle, filterServiceProvider } from 'Utils';
import {
    onUserNLDataChange,
    onUserUSDataChange,
    onUserILDataChange,
    onUserILNamesChange,
    onUserNLNamesChange,
    onUserUSNamesChange,
    onCustomerNamesChange,
    onSubModeDataChange,
    onShippingModeDataChange,
    onCountryOfOriginDataChange,
    onAirPoaDataChange,
    onAirPolDataChange,
    onLclPoaDataChange,
    onLclPolDataChange,
    onIncotermsDataChange,
    onFileCodesChange,
    onFCLType20DataChange,
    onFCLType40DataChange,
    onSortFilterChange,
} from 'reducers/order-reducers/predefinedDataSlicer';
import {
    onConsigneeIdChange,
    onCountryOfOriginIdChange,
    onShipperIdChange,
    onShippingModeIdChange,
    onSubModeIdChange,
    onUserLocalIdChange,
    onUserTracerChange,
    onUserCustomsChange,
    onUserAbroadIdChange,
    onIlReminderDateChange,
    OnStageSearchChange,
    onReminderDateChange,
    onOriginStateChange,
    resetOrderTableFilterSlice,
    resetAdvancedSearchFilter,
    onUrgentShipmentChange,
    onBrokerIdChange,
    onSelectedLocationIndexChange,
    onSelectedTabIndexNameChange,
    onSearchChange,
} from 'reducers/order-reducers/orderTableFilterSlicer';
import { onShipperNameOptionsChange, onShippersChange } from 'reducers/shippersSlicer';
import { onCustomerNameOptionsChange, onCustomersChange } from 'reducers/customersSlicer';
import { onConsigneeNameOptionsChange, onConsigneesChange } from 'reducers/consigneesSlicer';
import { snackbarToggle } from 'reducers/snackbarSlicer';

import ManageSearchIcon from '@mui/icons-material/ManageSearch';

const HistoryOrders = ({ selectedOrder, loginUser, agentOrders, redboxParcels, setIsUsTime, filterSpinner, setFilterSpinner, setSelectedOrder }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { state1 } = useSelector(state => state);
    const { unConfirmedOrdersCount } = useSelector(state => state.orders);
    const { subModeData, shippingModeData, countryOfOriginData, userILData, userNLData, userUSData, userNLNames, lclPolData, lclPoaData, airPoaData, airPolData } = useSelector(
        state => state.predefinedData,
    );
    const { incotermsData, userILNames, fclType20Data, fclType40Data } = useSelector(
        state => state.predefinedData,
    );

    const [searchText, setSearchText] = useState("");
    const [activeSearch, setActiveSearch] = useState(true);
    const [endDate, setEndDate] = useState(null);
    const [incotermsId, setIncotermsId] = useState(null);
    const [pageSize, setPageSize] = useState(20);
    const [pageNum, setPageNum] = useState(0);
    const [advOrderCount, setAdvOrderCount] = useState(0);
    const [fileNameSearch, setFileNameSearch] = useState(true);

    const onHandleSelectedLocationIndexChange = (event, newValue) => {
        dispatch(resetOrderTableFilterSlice(null));
        dispatch(onUserAbroadIdChange(null));
        dispatch(onSelectedLocationIndexChange(newValue));
        if (newValue === 'US') {
            setIsUsTime(1)
        } else {
            setIsUsTime(0)
        }
    }
    const { shippers } = useSelector(state => state.shippers);
    const { customers } = useSelector(state => state.customers);
    const { consignees } = useSelector(state => state.consignees);
    const [brokers, setBrokers] = useState([]);

    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);

    const [isLoaded, setIsLoaded] = useState(true);
    const [searchSpinner, setSearchSpinner] = useState(false);

    const {
        userLocalNumber,
        userAbroadNumber,
        consigneeId,
        customerId,
        shipperId,
        countryOfOriginId, originState,
        shippingModeId,
        subModeId,
        userLocalId,
        userTracer,
        userCustoms, urgentShipment,
        userAbroadId,
        dueDate,
        lastUpdateDate,
        ilReminderDate,
        reminderDate,
        selectedLocationIndex,
        selectedTabIndexName,
        search,
        startReminderDate,
        endReminderDate,
        startIlReminderDate,
        endIlReminderDate,
        stageSearch,
        stageStateSearch,
        reminderDateAdv, ilReminderDateAdv, sortFilter } = useSelector(state => state.orderTableFilter);
    const [airPolId, setAirPolId] = useState(null);
    const [airPodId, setAirPodId] = useState(null);
    const [seaPolId, setSeaPolId] = useState(null);
    const [seaPodId, setSeaPodId] = useState(null);
    const [etaStart, setEtaStart] = useState(null);
    const [etaEnd, setEtaEnd] = useState(null);
    const [etdStart, setEtdStart] = useState(null);
    const [etdEnd, setEtdEnd] = useState(null);
    const [reminderStart, setReminderStart] = useState(null);
    const [reminderEnd, setReminderEnd] = useState(null);
    const setAirPol = (data) => {
        setAirPolId(data);
        setSeaPolId(null);
    }
    const setSeaPol = (data) => {
        setAirPolId(null);
        setSeaPolId(data);
    }
    const setAirPod = (data) => {
        setAirPodId(data);
        setSeaPodId(null);
    }
    const setSeaPod = (data) => {
        setAirPodId(null);
        setSeaPodId(data);
    }
    const orderTableFilter = {
        userLocalNumber,
        userAbroadNumber,
        consigneeId,
        shipperId,
        countryOfOriginId, originState,
        shippingModeId,
        subModeId,
        userLocalId,
        userTracer,
        userCustoms, urgentShipment,
        userAbroadId,
        dueDate,
        lastUpdateDate,
        ilReminderDate,
        reminderDate,
        selectedLocationIndex,
        selectedTabIndexName,
        search,
        startReminderDate,
        endReminderDate,
        startIlReminderDate,
        endIlReminderDate,
        stageSearch,
        stageStateSearch,
        reminderDateAdv, ilReminderDateAdv, sortFilter
    };
    useEffect(() => {
        var sales = [];
        sales = userILNames.filter(name => name.department == 4);
        setUserILSales(sales);

        var importers = [];
        importers = userILNames.filter(name => name.department == 1 || name.department == null);
        setUserILImporters(importers);
    }, [userILNames]);
    const [globalSearchList, setGlobalSearchList] = useState([]);
    const [globalSearchList1, setGlobalSearchList1] = useState([]);
    const [globalSearch, setGlobalSearch] = useState(false);
    const [advSearchDialog, setAdvSearchDialog] = useState(false);
    const [userILImporters, setUserILImporters] = useState(false);
    const [userILSales, setUserILSales] = useState(false);
    const [userILSalesId, setUserILSalesId] = useState();
    const [userFU, setUserFU] = useState(null);
    const [rDate, setRDate] = useState(null);
    const [loc, setLoc] = useState("");
    const [cId, setCId] = useState(null);
    const [sId, setSId] = useState(null);
    const [ssId, setSSId] = useState(null);
    const [bId, setBId] = useState(null);
    const [cList, setCList] = useState(null);
    const [sList, setSList] = useState(null);
    const [ssList, setSSList] = useState(null);
    const [bList, setBList] = useState(null);
    const [eDate, setEDate] = useState(null);
    const [usState, setUsState] = useState(null);
    const [ctrId, setCtrId] = useState(null);
    const [stageId, setStageId] = useState(null);
    const onHandleOpenAdvSearchDialog = () => setAdvSearchDialog(true);
    const onHandleCancelAdvSearchDialog = () => setAdvSearchDialog(false);
    const [selectedGeneral, setSelectedGeneral] = useState(true);
    const onHandleChange = (event, action) => dispatch(action(event.target.value));
    const [fileNumber, setFileNumber] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        var spList = shippers.map(sp => {
            return {
                id: sp.id,
                name: sp.companyName
            };
        });
        setSList(spList);
    }, [shippers]);
    useEffect(() => {
        var spList = consignees.map(sp => {
            return {
                id: sp.id,
                name: sp.companyName
            };
        });
        setCList(spList);
    }, [consignees]);
    useEffect(() => {
        var spList = brokers.map(sp => {
            return {
                id: sp.id,
                name: sp.companyName
            };
        });
        setBList(spList);
    }, [brokers]);
    useEffect(() => {
        var spList = shippingModeData.map(sp => {
            return {
                id: sp.id,
                name: sp.name
            };
        });
        setSSList(spList);
    }, [shippingModeData]);
    const [sortFilter1, setSortFilter1] = useState({
        nlno: null,
        fu: null,
        ops: null,
        customs: null,
        type: null,
        orgCtr: null,
        orgUS: null,
        shipper: null,
        consignee: null,
        brooker: null,
        etd: null,
        eta: null,
        pol: null,
        pod: null,
        po: null,
        reminder: null,
        date: null,
        clientref: null,
        location: null,
    });
    const clearSort = () => {
        return {
            nlno: null,
            fu: null,
            ops: null,
            customs: null,
            type: null,
            orgCtr: null,
            orgUS: null,
            shipper: null,
            consignee: null,
            brooker: null,
            etd: null,
            eta: null,
            pol: null,
            pod: null,
            po: null,
            reminder: null,
            date: null,
            clientref: null,
            location: null,
        };
    }

    const csvExportAdv = () => {
        setSearchSpinner(true);
        var reap = globalSearchList1;
        var data_main = [];
        var header = ["File", "JOB", "PO", "Supplier Name", "QTY", "Package", "Weight", "Volume", "INCOTERMS", "Origin Country", "Load Port", "Discharge Port", "ETD", "ETA", "Vessel name", "Container", "Last Cus. Event"]
        //data_main.push(header);
        for (var i = 0; i < reap.length; i++) {
            var consignee = reap[i].consignee;
            var shipper = reap[i].shipper;
            var data = {
                "Customer": consignee?.companyShortName ? consignee?.companyShortName : (consignee?.companyName ? consignee.companyName : "-"),
                "File": getFileNumber(reap[i]),
                "JOB": reap[i].jobNumber ? reap[i].jobNumber : "-",
                "PO": reap[i]?.suppliersPO ? reap[i]?.suppliersPO : "-",
                "Sub Mode": getSubMode(reap[i]),
                "Supplier Name": shipper?.companyShortName ? shipper?.companyShortName : (shipper?.companyName ? shipper.companyName : "-"),
                "QTY": getOrderQuantity(reap[i]),
                "Package": reap[i].shippingModeId == 3 ? getFCLType(reap[i]) : "-",
                "Weight": getOrderWeight(reap[i]),
                "Volume": getOrderVolume(reap[i]),
                "INCOTERMS": getIncoterms(reap[i]),
                "Origin Country": getOriginCountry(reap[i]),
                "Load Port": getPOL(reap[i]),
                "Discharge Port": getPOD(reap[i]),
                "ETD": getETD(reap[i]),
                "ETA": getETA(reap[i]),
                "Vessel name": (reap[i]?.orderStage && reap[i]?.orderStage[4]?.departureStage[0]?.vesselNumber) ? reap[i]?.orderStage[4]?.departureStage[0]?.vesselNumber : "-",
                "Container": (reap[i]?.orderStage && reap[i]?.orderStage[4]?.departureStage[0]?.containerNumber) ? reap[i]?.orderStage[4]?.departureStage[0]?.containerNumber : "-",
                "AWB": reap[i]?.shippingModeId === 1 ? ((reap[i]?.orderStage && reap[i]?.orderStage[4]?.departureStage[0]?.awb) ? reap[i]?.orderStage[4]?.departureStage[0]?.awb : "-") : "-",
                "Flight": (reap[i]?.orderStage && reap[i]?.orderStage[4]?.departureStage[0]?.flightNumber) ? reap[i]?.orderStage[4]?.departureStage[0]?.flightNumber : "-",
                "Last Cus. Event": getLastEvent(reap[i]),
                "Reminder": getILReminder(reap[i]),
            };
            data_main.push(data);
        }
        jsonToExcel(data_main, "orders", header);
        setSearchSpinner(false);
    }
    const getILReminder = (order) => {
        if (order.ilRemindDate)
            return getDateE(order.ilRemindDate);
        return ""
    }
    const jsonToExcel = function (data, name, header) {
        var ws = XLSX.utils.json_to_sheet(data, header);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "All");
        XLSX.writeFile(wb, name + ".xlsx");
    }
    const getLocationFromId = (id) => {
        if (Number(id) == 1) {
            return "NL";
        } else if (Number(id) == 2) {
            return "EXP";
        } else if (Number(id) == 4) {
            return "US";
        } else if (Number(id) == 5) {
            return "ALL"
        }
    }
    const resetSearch = () => {
        setGlobalSearchList([]);
        setGlobalSearchList1([]);
        setPageNum(0);
        setAdvOrderCount(0);
    }
    const setSearchResult = (sort, ps, pn) => {
        setIsLoading(true);
        var list = [];
        setGlobalSearchList(list);
        var qp = "";
        if (loginUser.authority != "Admin" && loginUser.department != 4) {
            if (loginUser.department) {
                qp += "&userVisibility=" + loginUser.department;
            } else
                qp += "&userVisibility=1";
        }
        if (cId)
            qp += `&consigneeId=${cId}`;
        if (sId)
            qp += `&shipperId=${sId}`;
        if (bId)
            qp += `&customerId=${bId}`;
        if (ssId)
            qp += `&shippingModeId=${ssId}`;
        if (eDate) {
            var dt = new Date(eDate);
            dt.setUTCHours(23, 59, 59, 999);
            qp += `&etaDate=${dt.getTime()}`;
        }
        if (usState)
            qp += `&originState=${usState}`;
        if (ctrId)
            qp += `&countryOfOriginId=${ctrId}`;
        if (sort) {
            if (sort.date) {
                qp += `&sortdate=${sort.date}`;
            }
            if (sort.clientref) {
                qp += `&sortclientref=${sort.clientref}`;
            }
            if (sort.consignee) {
                qp += `&sortconsignee=${sort.consignee}`;
            }
            if (sort.shipper) {
                qp += `&sortshipper=${sort.shipper}`;
            }
            if (sort.brooker) {
                qp += `&sortbrooker=${sort.brooker}`;
            }
            if (sort.type) {
                qp += `&sorttype=${sort.type}`;
            }
            if (sort.etd) {
                qp += `&sortetd=${sort.etd}`;
            }
            if (sort.eta) {
                qp += `&sorteta=${sort.eta}`;
            }
            if (sort.orgCtr) {
                qp += `&sortorgctr=${sort.orgCtr}`;
            }
            if (sort.orgUS) {
                qp += `&sortorgus=${sort.orgUS}`;
            }
            if (sort.pol) {
                qp += `&sortpol=${sort.pol}`;
            }
            if (sort.pod) {
                qp += `&sortpod=${sort.pod}`;
            }
            if (sort.po) {
                qp += `&sortpo=${sort.po}`;
            }
            if (sort.reminder) {
                qp += `&sortreminder=${sort.reminder}`;
            }
            if (sort.location) {
                qp += `&sortlocation=${sort.location}`;
            }
            /*if (sortFilter1.date) {
                qp += `&sortdate=${sortFilter1.date}`;
            }*/
        }
        if (airPolId) {
            qp += `&polId=${airPolId}`;
        } else if (seaPolId) {
            qp += `&polId=${seaPolId}`;
        }
        if (airPodId) {
            qp += `&podId=${airPodId}`;
        } else if (seaPodId) {
            qp += `&podId=${seaPodId}`;
        }
        if (etaStart) {
            var dt = new Date(etaStart);
            const year = dt.getFullYear();
            const month = dt.getMonth();
            const day = dt.getDate();
            const utcTimestamp = new Date(Date.UTC(year, month, day, 5, 30, 0, 0));
            qp += `&startEta=${utcTimestamp.getTime()}`;
        }
        if (etaEnd) {
            var dt = new Date(etaEnd);
            const year = dt.getFullYear();
            const month = dt.getMonth();
            const day = dt.getDate();
            const utcTimestamp = new Date(Date.UTC(year, month, day, 5, 30, 0, 0));
            qp += `&endEta=${utcTimestamp.getTime()}`;
        }
        if (etdStart) {
            var dt = new Date(etdStart);
            const year = dt.getFullYear();
            const month = dt.getMonth();
            const day = dt.getDate();
            const utcTimestamp = new Date(Date.UTC(year, month, day, 5, 30, 0, 0));
            qp += `&startEtd=${utcTimestamp.getTime()}`;
        }
        if (etdEnd) {
            var dt = new Date(etdEnd);
            const year = dt.getFullYear();
            const month = dt.getMonth();
            const day = dt.getDate();
            const utcTimestamp = new Date(Date.UTC(year, month, day, 5, 30, 0, 0));
            qp += `&endEtd=${utcTimestamp.getTime()}`;
        }
        if (reminderStart) {
            var dt = new Date(reminderStart);
            const year = dt.getFullYear();
            const month = dt.getMonth();
            const day = dt.getDate();
            const utcTimestamp = new Date(Date.UTC(year, month, day, 5, 30, 0, 0));
            if (loginUser.location.id == 1)
                qp += `&startReminderDate=${utcTimestamp?.toISOString().replace("T", " ").split(".")[0]}`;
            else
                qp += `&startIlReminderDate=${utcTimestamp?.toISOString().replace("T", " ").split(".")[0]}`;
        }
        if (reminderEnd) {
            var dt = new Date(reminderEnd);
            const year = dt.getFullYear();
            const month = dt.getMonth();
            const day = dt.getDate();
            const utcTimestamp = new Date(Date.UTC(year, month, day, 5, 30, 0, 0));
            if (loginUser.location.id == 1)
                qp += `&endReminderDate=${utcTimestamp?.toISOString().replace("T", " ").split(".")[0]}`;
            else
                qp += `&endIlReminderDate=${utcTimestamp?.toISOString().replace("T", " ").split(".")[0]}`;
        }
        sendRequest("/api/order/count?showUnassignedOrders=true&" + (loginUser.department ? "dep=" + loginUser.department : "dep=1") + (endDate ? "&endDate=" + endDate : "") + (incotermsId ? "&incotermsId=" + incotermsId : "") + (globalSearch?.trim() ? "&search=" + globalSearch.trim() : "") + (activeSearch ? "&showHistoryOrdersOnly=false" : "&showHistoryOrdersOnly=true") + (userILSalesId ? ("&userLocalSalesId=" + userILSalesId) : "") + (userFU ? ("&userLocalId=" + userFU) : "") + (rDate ? ("&ilReminderDate=" + rDate) : "") + (loc ? ("&selectedLocation=" + loc) : "") + qp, REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                var ordersCount = response.ordersCount;
                if (ordersCount < 1) {
                    setIsLoading(false);
                    return;
                }
                setAdvOrderCount(ordersCount);
                sendRequest("/api/order/advOrders?showUnassignedOrders=true&" + (loginUser.department ? "dep=" + loginUser.department : "dep=1") + (ps ? "&size=" + ps : "") + (pn ? "&page=" + pn : "") + (endDate ? "&endDate=" + endDate : "") + (incotermsId ? "&incotermsId=" + incotermsId : "") + "&page=0&size=" + ordersCount + (globalSearch?.trim() ? "&search=" + globalSearch.trim() : "") + (activeSearch ? "&sort=2&showHistoryOrdersOnly=false" : "&sort=2&showHistoryOrdersOnly=true") + (userILSalesId ? ("&userLocalSalesId=" + userILSalesId) : "") + (userFU ? ("&userLocalId=" + userFU) : "") + (rDate ? ("&ilReminderDate=" + rDate) : "") + (loc ? ("&selectedLocation=" + loc) : "") + qp, REQUEST_ACTIONS.GET, '', {
                    successCallback: resp => {
                        var response = resp;
                        response = parseOrderData(resp);
                        var responses = [];
                        var alerts = [];
                        for (var i = 0; i < response.length; i++) {

                            var query = getLocationFromId(response[i].location.id);
                            if (loginUser.authority != "Admin") {
                                if (loginUser.department == null && response[i].visibilityWH)
                                    query += "-H";
                                else if (loginUser.department == 1 && response[i].visibilityWH)
                                    query += "-H";
                                else if (loginUser.department == 2 && response[i].visibilityT)
                                    query += "-H";
                                else if (loginUser.department == 3 && response[i].visibilityC)
                                    query += "-H";
                            } else if (response[i].historyFlag) {
                                query += "-H";
                            }
                            var consignee = response[i].consignee;
                            var shipper = response[i].shipper;
                            var reminderDateDisplay = response[i].ilRemindDate && loginUser?.location?.code === 'IL' ? new Intl.DateTimeFormat('en-GB', {
                                year: '2-digit',
                                month: '2-digit',
                                day: '2-digit',
                            }).format(response[i].ilRemindDate) :
                                response[i].remindDate && loginUser?.location?.code != 'IL' ? new Intl.DateTimeFormat('en-GB', {
                                    year: '2-digit',
                                    month: '2-digit',
                                    day: '2-digit',
                                }).format(response[i].remindDate) : '...';
                            list.push({
                                jobNumber: response[i].jobNumber,
                                date: formatDateTime(response[i].date),
                                rDate: reminderDateDisplay,
                                customerName: consignee?.companyShortName ? consignee?.companyShortName : (consignee?.companyName ? consignee?.companyName : ""),
                                clientPo: response[i].clientRefNumber,
                                shipperName: shipper?.companyShortName ? shipper?.companyShortName : (shipper?.companyName ? shipper?.companyName : ""),
                                mode: response[i].shippingMode.id == 3 ? "FCL" : (response[i].shippingMode.id == 2 ? "LCL" : "AIR"),
                                eta: getETA(response[i]),
                                etd: getETD(response[i]),
                                pol: response[i].pol?.name,
                                pod: response[i].poa?.name,
                                origin: (response[i].locationId != "4" ? countryOfOriginData.find(cty => cty.id == response[i].countryOfOriginId)?.name : USA_STATES.find(state => state.id == response[i].originState)?.name),
                                status: getLastEvent1(response[i]),
                                fileNumber: getFileNumber(response[i]),
                                location: query,
                            });
                            responses.push(response[i]);
                        }
                        setIsLoading(false);
                        setGlobalSearchList(list);
                        setGlobalSearchList1(responses);
                    },
                    failedCallback,
                });
            },
            failedCallback,
        });
    }
    const getLastEvent1 = (order) => {
        if (order.orderStatus) {
            if (order.orderStatus[8]?.status === "IN_PROGRESS" || order.orderStatus[8]?.status === "FAILED")
                return "Importer";
            if (order.orderStatus[7]?.status === "IN_PROGRESS" || order.orderStatus[7]?.status === "FAILED")
                return "Customs";
            if (order.orderStatus[6]?.status === "IN_PROGRESS" || order.orderStatus[6]?.status === "FAILED")
                return "ARR";
            if (order.orderStatus[5]?.status === "IN_PROGRESS" || order.orderStatus[5]?.status === "FAILED")
                return "DEP";
            if (order.orderStage[4]?.status === "IN_PROGRESS" || order.orderStage[4]?.status === "FAILED")
                return "PORT";
            if (order.orderStage[3]?.status === "IN_PROGRESS" || order.orderStage[3]?.status === "FAILED")
                return "WH";
            if (order.orderStage[2]?.status === "IN_PROGRESS" || order.orderStage[2]?.status === "FAILED")
                return "TRUCK";
            if (order.orderStage[1]?.status === "IN_PROGRESS" || order.orderStage[1]?.status === "FAILED")
                return "SHIPPER";
            if (order.orderStage[0]?.status === "IN_PROGRESS" || order.orderStage[0]?.status === "FAILED")
                return "Confirm";
        }
        return "-";
    }
    const getETA = (order) => {
        try {
            if (order?.astatus?.podDate)
                return getDate(order?.astatus?.podDate)
            if (order?.cstatus?.podDate)
                return getDate(order?.cstatus?.podDate)
            if (order.orderStage[4]?.departureStage[0]?.eta)
                return new Intl.DateTimeFormat('en-GB', {
                    year: '2-digit',
                    month: '2-digit',
                    day: '2-digit',
                    /* hour: '2-digit',
                     minute: '2-digit',
                     second: '2-digit',*/
                }).format(order.orderStage[4]?.departureStage[0]?.eta)
            return "";
        } catch (e) {
            return "";
        }
    }
    const getETD = (order) => {
        try {
            if (order?.astatus?.polDate)
                return getDate(order?.astatus?.polDate)
            if (order?.cstatus?.polDate)
                return getDate(order?.cstatus?.polDate)
            if (order.orderStage[4]?.departureStage[0]?.etd)
                return new Intl.DateTimeFormat('en-GB', {
                    year: '2-digit',
                    month: '2-digit',
                    day: '2-digit',
                    /* hour: '2-digit',
                     minute: '2-digit',
                     second: '2-digit',*/
                }).format(order.orderStage[4]?.departureStage[0]?.etd)
            return "";
        } catch (e) {
            return "";
        }
    }
    const getFileNumber = (order) => {
        if (order?.fileNumber)
            return order.fileNumber;
        if (order?.orderStage) {
            if (order?.orderStage[4]) {
                if (order?.orderStage[4]?.departureStage[0]?.fileNumber)
                    return order?.orderStage[4]?.departureStage[0]?.fileNumber;
            }
        }
        return "-";
    }
    const getOriginCountry = (order) => {
        var cty = countryOfOriginData?.find(country => country.id === order.countryOfOriginId);
        if (cty)
            return cty.name;
        return "-";
    }
    const getPOL = (order) => {
        var obj = null;
        if (order?.shippingModeId === 1) {
            obj = airPolData?.find(pol => pol.id === order.polId);
        }
        else
            obj = lclPolData?.find(pol => pol.id === order.polId);
        if (obj)
            return obj.name;
        return '-';
    }
    const getPOD = (order) => {
        var obj = null;
        if (order?.shippingModeId === 1) {
            obj = airPoaData?.find(pol => pol.id === order.poaId);
        }
        else
            obj = lclPoaData?.find(pol => pol.id === order.poaId);
        if (obj)
            return obj.name;
        return '-';
    }
    const getIncoterms = (order) => {
        var inc = incotermsData.find(inco => inco.id == order?.incotermsId);
        if (inc)
            return inc.name;
        return "-";
    }
    const getSubMode = (order) => {
        var sub = subModeData?.find(mode => mode.id === order.subModeId);
        if (sub)
            return sub.name;
        return "-";
    }
    const getFCLType = (order) => {
        var res = null;
        var res1 = null;
        if (order.orderFCLDetails?.fclType20Id) {
            res = fclType20Data.find(fcl => fcl.id == order.orderFCLDetails?.fclType20Id);
            if (order.orderFCLDetails?.fclType40Id) {
                res1 = fclType40Data.find(fcl => fcl.id == order.orderFCLDetails?.fclType40Id);
            }
        }
        else if (order.orderFCLDetails?.fclType40Id) {
            res = fclType40Data.find(fcl => fcl.id == order.orderFCLDetails?.fclType40Id);
        }
        return res ? res.name + (res1 ? (", " + res1.name) : "") : "-"
    }
    const getLastEvent = (order) => {
        if (order.orderStatus) {
            if (order.orderStatus[8]?.status === "IN_PROGRESS" || order.orderStatus[8]?.status === "FAILED")
                return "Delivery to Consignee";
            if (order.orderStatus[7]?.status === "IN_PROGRESS" || order.orderStatus[7]?.status === "FAILED")
                return "Customs - " + getCustomStatus(order);
            if (order.orderStatus[6]?.status === "IN_PROGRESS" || order.orderStatus[6]?.status === "FAILED")
                return "POD - " + getPodStatus(order);
            if (order.orderStatus[5]?.status === "IN_PROGRESS" || order.orderStatus[5]?.status === "FAILED")
                return "POL - " + getPodStatus(order);
            if (order.orderStage[4]?.status === "IN_PROGRESS" || order.orderStage[4]?.status === "FAILED")
                return "Departure Waiting";
            if (order.orderStage[3]?.status === "IN_PROGRESS" || order.orderStage[3]?.status === "FAILED")
                return "In Warehouse";
            if (order.orderStage[2]?.status === "IN_PROGRESS" || order.orderStage[2]?.status === "FAILED")
                return "In Trucking";
            if (order.orderStage[1]?.status === "IN_PROGRESS" || order.orderStage[1]?.status === "FAILED")
                return "In Shipper";
            if (order.orderStage[0]?.status === "IN_PROGRESS" || order.orderStage[0]?.status === "FAILED")
                return "Need Confirmation";
        }
        return "-";
    }
    const getPodStatus = (order) => {
        var res = 0;
        if (order.shippingModeId == 1) {
            res = order.airStatus?.lStatus ? order.airStatus?.lStatus : "";
        } else {
            res = getSinayStatus(order.sinay?.status?.val?.metadata?.shippingStatus ? order.sinay?.status?.val?.metadata?.shippingStatus : "", order.sinay?.status ? order.sinay?.status : "")
        }
        return res ? res : "";
    }
    const getCustomStatus = (order) => {
        if (order.shippingModeId == 1) {
            return order.airStatus?.lStatus ? order.airStatus?.lStatus : "";
        } else {
            return getTaskyamStatus(order.taskyam?.data?.status)
        }
    }
    const getSinayStatus = (str, status) => {
        var msg = status?.val?.message ? status?.val?.message : "";
        if (msg) {
            return msg;
        }
        return str;
    }
    const getTaskyamStatus = (id) => {
        switch (id) {
            case 0:
                return "";
            case 1:
                return "מצהר";
            case 2:
                return "זמינות";
            case 3:
                return "פקודת מסירה";
            case 4:
                return "בדיקת מכס";
            case 5:
                return "התרת מכס";
            case 6:
                return "התרת נמל";
            case 7:
                return "תעודת ליווי";
            case 8:
                return "בקשה להוצאה";
            case 9:
                return "משוב מהנמל";
            case 10:
                return "יציאת מטען";
        }
        return "-"
    }
    const formatDateTime = (date) => {
        if (!date)
            return "-";
        var dt = new Date(Number(date));
        const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
        return `${padL(dt.getDate())}/${padL(dt.getMonth() + 1)}/${dt.getFullYear().toString()}`;
    }
    const getOrderQuantity = (order) => {
        var res = 0;
        if (order.orderDetails) {
            for (var i = 0; i < order.orderDetails.length; i++) {
                res += order.orderDetails[i].numberOfPieces;
            }
        }
        if (order.orderFCLDetails?.quantity40) {
            res += order.orderFCLDetails.quantity40
        }
        if (order.orderFCLDetails?.quantity20) {
            res += order.orderFCLDetails.quantity20
        }
        return res ? res : "";
    }
    const getOrderWeight = (order) => {
        var res = 0;
        if (order.orderDetails) {
            for (var i = 0; i < order.orderDetails.length; i++) {
                res += order.orderDetails[i].numberOfPieces * order.orderDetails[i].weightPerPiece;
            }
        }
        return res ? res : "";
    }
    const getOrderVolume = (order) => {
        var res = 0;
        if (order.orderDetails) {
            for (var i = 0; i < order.orderDetails.length; i++) {
                res += (order.orderDetails[i].numberOfPieces * order.orderDetails[i].height * order.orderDetails[i].width * order.orderDetails[i]["length"]) / 1000000;
            }
        }
        return res ? res : "";
    }

    useEffect(() => {
        dispatch(resetOrderTableFilterSlice(null));
        if (location?.state?.name == "location") {
            var loc = (location?.state.locInd && location?.state.locInd != -1) ? location?.state.locInd : 0;
            dispatch(onSelectedLocationIndexChange(loc));
            dispatch(onSelectedTabIndexNameChange(location?.state?.tabInd));
            dispatch(onSearchChange(location?.state?.search));
            setGlobalSearch(location?.state?.searchText);
            setGlobalSearchList(location?.state?.searchList);
            setGlobalSearchList1(location?.state?.searchList1);
        }
    }, []);

    useEffect(() => {
        sendRequest('/api/getAllData', REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                console.log(response);
                dispatch(onSubModeDataChange(response.subMode));
                dispatch(onShippingModeDataChange(response.shippingMode));
                dispatch(onAirPoaDataChange(response.poaair));
                dispatch(onAirPolDataChange(response.polair));
                dispatch(onLclPoaDataChange(response.poalcl));
                dispatch(onLclPolDataChange(response.pollcl));
                dispatch(onCountryOfOriginDataChange(response.countryOfOrigin));
                dispatch(onIncotermsDataChange(response.incoterms));
                dispatch(onFileCodesChange(response.codes));
                dispatch(onFCLType20DataChange(response.fclType20));
                dispatch(onFCLType40DataChange(response.fclType40));
            },
            failedCallback,
        });
        sendRequest('/api/usersAll', REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                console.log(response);
                dispatch(onUserILDataChange(response.IL));
                dispatch(onUserNLDataChange(response.NL));
                dispatch(onUserUSDataChange(response.US));
            },
            failedCallback,
        });
        sendRequest('/api/serviceProvider/all?activeFlag=true', REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                dispatch(onShippersChange(response.s1));
                dispatch(onConsigneesChange(response.s2));
                //setColoaders(response.s8);
                dispatch(onCustomersChange(response.s13));
                setBrokers(response.s12);
            },
            failedCallback,
        });
        /*// predefined sub mode data get
        sendRequest('/api/subMode', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onSubModeDataChange(response)),
            failedCallback,
        });

        // predefined shipping mode data get
        sendRequest('/api/shippingMode', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onShippingModeDataChange(response)),
            failedCallback,
        });

        // predefined country of origin data get
        sendRequest('/api/countryOfOrigin', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onCountryOfOriginDataChange(response)),
            failedCallback,
        });

        // predefined shippers data get
        sendRequest('/api/serviceProvider/1?activeFlag=true', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onShippersChange(response)),
            failedCallback,
        });

        // predefined consignee data get
        sendRequest('/api/serviceProvider/2?activeFlag=true', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onConsigneesChange(response)),
            failedCallback,
        });

        // predefined customer data get
        sendRequest('/api/serviceProvider/13?activeFlag=true', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onCustomersChange(response)),
            failedCallback,
        });

        // predefined user local data get
        sendRequest('/api/users/IL', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onUserILDataChange(response)),
            failedCallback,
        });

        // predefined user abroad data get
        sendRequest('/api/users/NL', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onUserNLDataChange(response)),
            failedCallback,
        });

        // predefined user abroad data get
        sendRequest('/api/users/US', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onUserUSDataChange(response)),
            failedCallback,
        });

        // predefined air poa data get
        sendRequest('/api/poa/air', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onAirPoaDataChange(response)),
            failedCallback,
        });

        // predefined air pol data get
        sendRequest('/api/pol/air', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onAirPolDataChange(response)),
            failedCallback,
        });

        // predefined lcl poa data get
        sendRequest('/api/poa/lcl', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onLclPoaDataChange(response)),
            failedCallback,
        });

        // predefined lcl pol data get
        sendRequest('/api/pol/lcl', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onLclPolDataChange(response)),
            failedCallback,
        });

        // predefined incoterms data get
        sendRequest('/api/incoterms', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onIncotermsDataChange(response)),
            failedCallback,
        });

        // predefined code data get
        sendRequest('/api/codes', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onFileCodesChange(response)),
            failedCallback,
        });*/
    }, [dispatch, failedCallback]);

    useEffect(() => {
        const userILNameOptions = userILData.map(user => ({
            id: user.id,
            name: user.fullName,
            department: user.department,
        }));

        dispatch(onUserILNamesChange(userILNameOptions));
    }, [userILData, dispatch]);

    useEffect(() => {
        const userNLNameOptions = userNLData.map(user => ({
            id: user.id,
            name: user.fullName,
        }));

        dispatch(onUserNLNamesChange(userNLNameOptions));
    }, [userNLData, dispatch]);

    useEffect(() => {
        const userUSNameOptions = userUSData.map(user => ({
            id: user.id,
            name: user.fullName,
        }));

        dispatch(onUserUSNamesChange(userUSNameOptions));
    }, [userUSData, dispatch]);

    useEffect(() => {
        const shipperNameOptions = shippers.map(shipper => ({
            id: shipper.id,
            name: shipper.companyName,
            serviceProviderLocationId: shipper.serviceProviderLocationId,
        }));

        dispatch(onShipperNameOptionsChange(shipperNameOptions));
    }, [shippers, dispatch]);

    useEffect(() => {
        const customerNameOptions = customers.map(customer => ({
            id: customer.id,
            name: customer.companyName,
            serviceProviderLocationId: customer.serviceProviderLocationId,
        }));

        dispatch(onCustomerNameOptionsChange(customerNameOptions));
    }, [customers, dispatch]);

    useEffect(() => {
        const consigneeNameOptions = consignees.map(consignee => ({
            id: consignee.id,
            name: consignee.companyName,
            serviceProviderLocationId: consignee.serviceProviderLocationId,
        }));

        dispatch(onConsigneeNameOptionsChange(consigneeNameOptions));
    }, [consignees, dispatch]);

    useEffect(() => {
        setIsLoaded(subModeData && shippingModeData && countryOfOriginData && userILData && userNLData && userUSData);
    }, [subModeData, shippingModeData, countryOfOriginData, userILData, userNLData, userUSData]);



    return (
        <Grid container container style={{ display: `${selectedOrder ? "none" : ""}` }}>
            {!isLoaded ? (
                <Grid container item justifyContent='center' mt={8}>
                    <CircularProgress />
                </Grid>
            ) : (
                <Fragment>
                    <Grid container rowSpacing={1} sx={{ padding: "0" }}>
                        {!(loginUser?.authorities && loginUser?.authorities[0]?.authority === 'User' && (loginUser?.location?.code === 'NL' || loginUser?.location?.code === 'US')) ?
                            (
                                <Grid item xs={12} alignItems="center" sx={{ padding: "0", margin: "0" }}>
                                    <Tabs value={selectedLocationIndex} onChange={onHandleSelectedLocationIndexChange} className="locationTabsGroup" TabIndicatorProps={{ style: { display: 'none' } }} sx={{ minHeight: "30px", overflow: "hidden" }}>
                                        <StyledTab label="NL" className="locationTab" />
                                        <StyledTab label="US" className="locationTab" />
                                        <StyledTab label="OTHERS" className="locationTab" />
                                        <StyledTab label="EXP" className="locationTab" />
                                    </Tabs>
                                </Grid>) : null}
                        <Grid container item spacing={1} style={{ marginTop: '0' }}>
                            <Grid container item xs={8} spacing={1} style={{ paddingTop: "0", marginTop: '0' }} className="subtabs">
                                {/* <Typography noWrap variant='h5'>Orders History</Typography>*/}
                                    <Button variant='contained' className={selectedTabIndexName !== 'OrdersHistory' ? 'active' : ''} sx={{ fontWeight: "700", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "30px", minWidth: "150px", fontSize: "0.75vw !important" }} onClick={() => {
                                        dispatch(onSelectedTabIndexNameChange("Orders"));
                                        dispatch(getOrders([]));
                                        dispatch(onPageChange(0));
                                        dispatch(onUnConfirmedOrdersCountChange(''));
                                        window.setTimeout(function () {
                                            navigate("/home", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Orders" } })
                                        }, 500)
                                        //agentOrders()
                                    }}>
                                        &#9638;&nbsp; Orders
                                    </Button>
                                    <Button color='secondary' variant='contained' className={selectedTabIndexName === 'OrdersHistory' ? 'active' : ''} sx={{ fontWeight: "700", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "0px", minWidth: "150px", fontSize: "0.75vw !important" }} onClick={() => {
                                        dispatch(onSelectedTabIndexNameChange("OrdersHistory"));
                                        dispatch(getOrders([]));
                                        // navigate("/home", { state: { name: "location", locInd: selectedLocationIndex } })
                                        dispatch(onPageChange(0));
                                        dispatch(onUnConfirmedOrdersCountChange(''));
                                        window.setTimeout(function () {
                                            navigate("/orderHistory", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "OrdersHistory" } })
                                        }, 500)
                                    }}>
                                        &#9724;&nbsp; Order History
                                    </Button>
                                    {/*<Button color='secondary' className={selectedTabIndexName !== 'OrdersHistory' ? 'active' : ''} variant='contained' sx={{ fontWeight: "400", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "25px", width: "11%", fontSize: "1vw !important" }} onClick={() => {
                                    dispatch(onSelectedTabIndexNameChange("Orders"));
                                    dispatch(getOrders([]));
                                    dispatch(onPageChange(0));
                                    dispatch(onUnConfirmedOrdersCountChange(''));
                                    window.setTimeout(function () {
                                        navigate("/home", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Orders" } })
                                    }, 500)
                                    //agentOrders()
                                }}>
                                    Orders
                                </Button>
                                <Button variant='contained' className={selectedTabIndexName === 'OrdersHistory' ? 'active' : ''} sx={{ fontWeight: "400", textTransform: "none", backgroundColor: "#1976d270 !important", height: "2.2vw", marginTop: "3px", width: "19%", fontSize: "1vw !important" }} onClick={() => {
                                    dispatch(onSelectedTabIndexNameChange("OrdersHistory"));
                                    dispatch(getOrders([]));
                                    // navigate("/home", { state: { name: "location", locInd: selectedLocationIndex } })
                                    dispatch(onPageChange(0));
                                    dispatch(onUnConfirmedOrdersCountChange(''));
                                    window.setTimeout(function () {
                                        navigate("/orderHistory", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "OrdersHistory" } })
                                    }, 500)
                                }}>
                                    Order History{unConfirmedOrdersCount ? ' (' + unConfirmedOrdersCount + ')' : ''}
                                </Button>*/}
                                {/*{selectedLocationIndex != 2 && <Button color='secondary' variant='contained' sx={{ fontWeight: "400", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "11%", fontSize: "1vw !important" }} onClick={() => {
                                    dispatch(onSelectedTabIndexNameChange("Parcels"));
                                    dispatch(getOrders([]));
                                    dispatch(onPageChange(0));
                                    dispatch(onUnConfirmedParcelsCountChange(''));
                                    window.setTimeout(function () {
                                        navigate("/phome", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Parcels" } })
                                    }, 500)
                                    //redboxParcels()
                                }}>
                                    Redbox
                                </Button>
                                }
                                {selectedLocationIndex != 2 && <Button color='secondary' variant='contained' sx={{ fontWeight: "400", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "17%", fontSize: "1vw !important" }} onClick={() => {
                                    dispatch(onSelectedTabIndexNameChange("ParcelsHistory"));
                                    dispatch(getOrders([]));
                                    // navigate("/home", { state: { name: "location", locInd: selectedLocationIndex } })
                                    dispatch(onPageChange(0));
                                    dispatch(onUnConfirmedParcelsCountChange(''));
                                    window.setTimeout(function () {
                                        navigate("/parcelHistory", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "ParcelsHistory" } })
                                    }, 500)
                                    //redboxParcels()
                                }}>
                                    Redbox History
                                </Button>
                                }
                                {selectedLocationIndex != 2 && <Button color='secondary' variant='contained' sx={{ fontWeight: "400", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "11%", fontSize: "1vw !important" }} onClick={() => {
                                    dispatch(onSelectedTabIndexNameChange("Drops"));
                                    dispatch(getOrders([]));
                                    dispatch(onPageChange(0));
                                    dispatch(onUnConfirmedParcelsCountChange(''));
                                    window.setTimeout(function () {
                                        navigate("/dhome", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Drops" } })
                                    }, 500)
                                    //redboxParcels()
                                }}>
                                    Drop
                                </Button>
                                }
                                {selectedLocationIndex != 2 && <Button color='secondary' variant='contained' sx={{ fontWeight: "400", textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "17%", fontSize: "1vw !important" }} onClick={() => {
                                    dispatch(onSelectedTabIndexNameChange("DropsHistory"));
                                    dispatch(getOrders([]));
                                    // navigate("/home", { state: { name: "location", locInd: selectedLocationIndex } })
                                    dispatch(onPageChange(0));
                                    dispatch(onUnConfirmedParcelsCountChange(''));
                                    window.setTimeout(function () {
                                        navigate("/dropHistory", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "DropsHistory" } })
                                    }, 500)
                                    //redboxParcels()
                                }}>
                                    Drop History
                                </Button>}*/}
                            </Grid>
                            <Grid container item xs={4} justifyContent='flex-end' flexWrap="nowrap" className="orders-actions">
                                <Grid container item xs={8} justifyContent='flex-end' alignContent="flex-start" flexWrap="nowrap" className="action-buttons">
                                    <Button color='primary' onClick={() => {
                                        onHandleOpenAdvSearchDialog();
                                        }} variant='contained' className="icon-btn" sx={{ background: "#fff", borderRadius: "12px", width: "46px", minWidth: "auto", padding: "0", height: "46px", fontSize: "20px", fontWeight: "700", margin: "0.8vw 2vw;" }}>
                                        ☷⌕
                                    </Button>
                                </Grid>
                                {advSearchDialog &&
                                    <Dialog
                                        open={advSearchDialog}
                                        onHandleCancel={onHandleCancelAdvSearchDialog}
                                        title='Advanced Search'
                                        maxWidth="90vw">
                                            <AdvSearchDialog
                                                selectedGeneral={selectedGeneral}
                                                setSelectedGeneral={setSelectedGeneral}
                                                onHandleChange={onHandleChange}
                                                subModeId={subModeId}
                                                subModeData={subModeData}
                                                onSubModeIdChange={onSubModeIdChange}
                                                STAGES_OPTIONS={STAGES_OPTIONS}
                                                stageSearch={stageSearch}
                                                OnStageSearchChange={OnStageSearchChange}
                                                fileNumber={fileNumber}
                                                setFileNumber={setFileNumber}
                                                urgentShipment={urgentShipment}
                                                onUrgentShipmentChange={onUrgentShipmentChange}
                                                advancedSearchDefaultStyle={advancedSearchDefaultStyle}
                                                resetAdvancedSearchFilter={resetAdvancedSearchFilter}
                                                globalSearch={globalSearch} setGlobalSearch={setGlobalSearch}
                                                setSearchResult={setSearchResult}
                                                isLoading={isLoading}
                                                CircularProgress={CircularProgress}
                                                globalSearchList={globalSearchList}
                                                selectedLocationIndex={selectedLocationIndex}
                                                onSelectedLocationIndexChange={onSelectedLocationIndexChange}
                                                onSearchChange={onSearchChange}
                                                setSearchSpinner={setSearchSpinner}
                                                setSearchText={setSearchText}
                                                dispatch={dispatch}
                                                sendRequest={sendRequest}
                                                failedCallback={failedCallback}
                                                onHandleCancelAdvSearchDialog={onHandleCancelAdvSearchDialog}
                                                setOrderData={setOrderData} loginUser={loginUser}
                                                getOrders={getOrders} csvExportAdv={csvExportAdv}
                                                resetOrderTableFilterSlice={resetOrderTableFilterSlice}
                                                origin={"H"}
                                                globalSearchList1={globalSearchList1}
                                                activeSearch={activeSearch}
                                                setActiveSearch={setActiveSearch}
                                                setEndDate={setEndDate}
                                                userILSalesId={userILSalesId}
                                                setUserILSalesId={setUserILSalesId}
                                                userILSales={userILSales}
                                                incotermsData={incotermsData}
                                                setIncotermsId={setIncotermsId}
                                                setUserFU={setUserFU}
                                                userFU={userFU}
                                                userFUData={userILImporters}
                                                rDate={rDate}
                                                setRDate={setRDate}
                                                setLoc={setLoc}
                                                cId={cId}
                                                sId={sId}
                                                ssId={ssId}
                                                setCId={setCId}
                                                setSId={setSId}
                                                setSSId={setSSId}
                                                cList={cList}
                                                sList={sList}
                                                ssList={ssList}
                                                bId={bId}
                                                setBId={setBId}
                                                bList={bList}
                                                eDate={eDate}
                                                setEDate={setEDate}
                                                usState={usState}
                                                setUsState={setUsState}
                                                ctrId={ctrId}
                                                setCtrId={setCtrId}
                                                stageId={stageId}
                                                setStageId={setStageId}
                                                ctrList={countryOfOriginData}
                                                resetSearch={resetSearch}
                                                orderCount={advOrderCount}
                                                pageSize={pageSize}
                                                setPageSize={setPageSize}
                                                pageNum={pageNum}
                                                setPageNum={setPageNum}
                                                sortFilter={sortFilter1}
                                                onSortFilterChange={setSortFilter1}
                                                clearSort={clearSort}
                                                setAirPol={setAirPol}
                                                setAirPod={setAirPod}
                                                setSeaPol={setSeaPol}
                                                setSeaPod={setSeaPod}
                                                airPolId={airPolId}
                                                airPodId={airPodId}
                                                seaPolId={seaPolId}
                                                seaPodId={seaPodId}
                                                etaStart={etaStart}
                                                etaEnd={etaEnd}
                                                etdStart={etdStart}
                                                etdEnd={etdEnd}
                                                setEtaStart={setEtaStart}
                                                setEtaEnd={setEtaEnd}
                                                setEtdStart={setEtdStart}
                                                setEtdEnd={setEtdEnd}
                                                reminderStart={reminderStart}
                                                reminderEnd={reminderEnd}
                                                setReminderStart={setReminderStart}
                                                setReminderEnd={setReminderEnd} />

                                    </Dialog>
                                }

                            </Grid>
                        </Grid>
                    </Grid>

                    <OrderTable setSelectedOrder={setSelectedOrder} filterSpinner={filterSpinner} setFilterSpinner={setFilterSpinner} loginUser={loginUser} searchSpinner={searchSpinner} pageName='orderHistory' searchText={searchText} setSearchText={setSearchText} />
                </Fragment>
            )}
        </Grid>
    );
};

export default HistoryOrders;

export const StyledTab = styled(Tab)({
    border: 'none',
    'font-size': '17px',
    'margin-right': '2px',
    'padding': '14px 16px',
    'min-height': '30px',
});
